if (!customElements.get('video-testimonials')) {
  class VideoTestimonials extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.video-testimonials__track');
      this.bar = this.querySelector('.video-testimonials__bar');
      this.thumb = this.querySelector('.video-testimonials__bar-thumb');

      this.addEventListener('click', this.onClick.bind(this));

      if (this.track && this.bar && this.thumb) {
        this.updateBar = this.updateBar.bind(this);
        this.track.addEventListener('scroll', this.updateBar, { passive: true });
        window.addEventListener('resize', this.updateBar);
        this.thumb.addEventListener('pointerdown', this.onDragStart.bind(this));
        this.updateBar();
      }
    }

    disconnectedCallback() {
      if (this.updateBar) window.removeEventListener('resize', this.updateBar);
    }

    onClick(e) {
      const tile = e.target.closest('.video-testimonials__tile');
      if (!tile) return;

      const video = tile.querySelector('video');
      if (!video) return;

      if (video.paused) {
        this.playOnly(video, tile);
      } else {
        video.pause();
        tile.classList.remove('is-playing');
      }
    }

    /** Plays one video with sound; pauses and mutes all others. */
    playOnly(video, tile) {
      this.querySelectorAll('.video-testimonials__tile').forEach((other) => {
        if (other === tile) return;
        const v = other.querySelector('video');
        if (v) {
          v.pause();
          v.muted = true;
        }
        other.classList.remove('is-playing');
      });

      video.muted = false;
      tile.classList.add('is-playing');

      const playPromise = video.play();
      if (playPromise) playPromise.catch(() => {});
    }

    /** Sync the custom scrollbar thumb to the scroll position. */
    updateBar() {
      const { scrollWidth, clientWidth, scrollLeft } = this.track;
      const maxScroll = scrollWidth - clientWidth;

      if (maxScroll <= 1) {
        this.bar.hidden = true;
        return;
      }

      this.bar.hidden = false;
      const thumbPct = Math.max((clientWidth / scrollWidth) * 100, 10);
      const posPct = (scrollLeft / maxScroll) * (100 - thumbPct);
      this.thumb.style.width = `${thumbPct}%`;
      this.thumb.style.left = `${posPct}%`;
    }

    /** Drag the thumb to scroll the row. */
    onDragStart(e) {
      e.preventDefault();
      const maxThumb = this.bar.clientWidth - this.thumb.clientWidth;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      if (maxThumb <= 0) return;

      const startX = e.clientX;
      const startScroll = this.track.scrollLeft;
      this.thumb.setPointerCapture(e.pointerId);

      const onMove = (ev) => {
        const dx = ev.clientX - startX;
        this.track.scrollLeft = startScroll + (dx / maxThumb) * maxScroll;
      };
      const onUp = (ev) => {
        this.thumb.releasePointerCapture(ev.pointerId);
        this.thumb.removeEventListener('pointermove', onMove);
        this.thumb.removeEventListener('pointerup', onUp);
        this.thumb.removeEventListener('pointercancel', onUp);
      };

      this.thumb.addEventListener('pointermove', onMove);
      this.thumb.addEventListener('pointerup', onUp);
      this.thumb.addEventListener('pointercancel', onUp);
    }
  }

  customElements.define('video-testimonials', VideoTestimonials);
}
